<div class="main">
  <div ngStyle.xs="padding-inline:0" fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxLayoutGap="10"
    fxLayoutGap.xs="0" fxLayoutGap.sm="0" class="adver main_ads ">
    <!-- <div fxFlexAlign="center" class="ad_div hide_ad_mobile" fxFlex.lg="100" fxFlex.xl="100" fxFlex.md="100"
      fxFlex.xs="100" fxFlex.sm="100" fxLayoutAlign="center">
      <a href="https://bit.ly/4dPbkZD" target="_blank" rel="noopener">
        <img loading="lazy" style="display: block; width: 100%;   margin:auto"
          src="https://cdn.newsfirst.lk/advertisements/05-09-2024/720X90-%20sirasa%20floating.jpg" alt="" /></a>
    </div>

    <div fxFlexAlign="center" class="ad_div hide_ad_lap" fxFlex.lg="50" fxFlex.xl="50" fxFlex.md="50" fxFlex.xs="100"
      fxFlex.sm="100" fxLayoutAlign="center">
      <a href="https://bit.ly/4dPbkZD" target="_blank" rel="noopener">
        <img loading="lazy" style="display: block; width: 100%;   margin:auto"
          src="https://cdn.newsfirst.lk/advertisements/05-09-2024/720X90-%20sirasa%20floating.jpg" alt="" /></a>
    </div> -->
  </div>

  <div class="padding">

    <!-- <ins class="adsbygoogle" style="display:inline-block;width:728px;height:90px; min-width: 100%;"
      data-ad-client="ca-pub-5432073672371728" data-ad-slot="1098464258"></ins> -->

    <!-- <app-advertisement></app-advertisement> -->
    <!-- <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="20" class="adver">
      <div fxFlexAlign="center" class="ads" fxFlex="50" fxLayoutAlign="center">
        <img src="https://cdn.newsfirst.lk/english-uploads/2022/03/a00a4916-outlook-4xm0xdn4.gif" alt="">
      </div>
      <div fxFlexAlign="center" class="ads" fxFlex="50" fxLayoutAlign="center">
        <img src="https://storage.googleapis.com/cdn-newsfirst-lk-v2/statics/ads2.jpg" alt="">
      </div>
    </div> -->
    <!-- =============================================== -->

    <div fxLayout="row" class="we_report" style="margin: 30px;">
      <div fxFlex="30" fxFlex.sm="25" fxFlex.xs="20" class="top_header_left"></div>
      <div fxFlex="40" fxFlex.sm="50" fxFlex.xs="60" class="top_header">#PowerofThePeople</div>
      <div fxFlex="30" fxFlex.sm="25" fxFlex.xs="20" class="top_header_right"></div>

    </div>
    <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10" class="adver" style="margin-bottom: 20px;">

      <div fxFlexAlign="center" class="ad_div  hide_ad_lap" fxFlex="75" fxFlex.xs="100" fxFlex.sm="100"
        fxLayoutAlign="center">
        <a href="https://news1st.lk/3MS0FRU" target="_blank" rel="noopener">
          <img loading="lazy" style=" margin: auto;height:100% !important; width: 100%;  "
            src="https://cdn.newsfirst.lk/advertisements/2025-05-06/web-banner-01.png" alt="" />
        </a>
      </div>

      <div fxFlexAlign="center" class="ad_div hide_ad_mobile" fxFlex="75" fxFlex.xs="100" fxFlex.sm="100"
        fxLayoutAlign="center">
        <a href="https://news1st.lk/3MS0FRU" target="_blank" rel="noopener">
          <img loading="lazy" style=" margin: auto;height:100% !important; width: 100%;  "
            src="https://cdn.newsfirst.lk/advertisements/2025-05-06/web-banner-02.png" alt="" />
        </a>
      </div>
    </div>

    <!-- <div fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxLayoutGap="10" fxLayoutGap.xs="10"
      fxLayoutGap.sm="10" class="adver  ">
      <div fxFlexAlign="center" class="ad_div  hide_ad_lap_new" fxFlex="100" fxFlex.xs="100" fxFlex.sm="100"
        fxLayoutAlign="center">
        <a href="https://news1st.lk/3MS0FRU" target="_blank" rel="noopener" style="width: 100%;">
          <iframe style="width: 100% !important;" src="https://election-graph-tv-new.pages.dev"
            frameborder="0"></iframe>
        </a>
      </div>
    </div> -->

    <div fxLayout="row" fxLayoutGap="10" fxLayout.sm="column" fxLayout.xs="column">
      <div fxFlex.lg="25" fxFlex.xl="25" fxFlex.md="25" fxFlex.sm="100" fxFlex.xs="100" fxLayout="column"
        fxFlexOrder="1" fxFlexOrder.sm="2" fxFlexOrder.xs="2">
        <div>
          <div class="black_header">
            <!-- latest -->
            <div class="black_header_title display-flex">புதியவை</div>
          </div>
          <div class="main_div">
            <div class="main_inner_div">
              <div class="latest_news_main_div" *ngFor="let item of latestPost  let i=index">
                <a href="/{{item.post_url}}">
                  <div>
                    <!-- <div class="time_date"> {{item.date.split("T")[0]}} | {{item.date.split("T")[1].split(".")[0]}}</div> -->
                    <div>
                      <div class="textWrap">
                        <!-- <img class="latest_news_img" style="object-fit: cover;" width="100%" alt={{item.short_title}}
                          [src]="item.images.mini_tile_image"> -->
                        <div style="position: relative;">
                          <div *ngIf="item.video_post!=null" style="width: 80px;height: 80px;" class="video_play_main ">
                            <img src="https://cdn.newsfirst.lk/assets/play.png" alt="">
                          </div>
                          <img loading="lazy" class="latest_news_img" style="object-fit: cover;" width="100%"
                            alt={{item.short_title}} [src]="item.images.post_thumb">
                        </div>
                      </div>
                      <h4 style="margin-block: 8px !important;" class="sub_news_title new_height_sub_news">
                        {{item.short_title}}</h4>

                      <p class="latest_news_detail"
                        [innerHTML]="replaceString(item.excerpt.rendered).substring(0, 300)+'...'">

                      </p>

                    </div>
                  </div>
                  <div fxLayout="row" class="time_readMore">
                    <div fxFlex="50">
                      <div class="time_date"> {{item.date.split("T")[0]}} | {{item.date.split("T")[1].split(".")[0]}}
                      </div>
                    </div>
                    <div fxFlex="50" class="read_more_main">
                      <div class="read_more">மேலும் வாசிக்க </div>
                    </div>
                  </div>

                </a>
                <mat-divider class="divider"></mat-divider>

              </div>


            </div>

          </div>
          <div class="Learn_more_main">
            <a href="/latest">
              <div class="display-flex Learn_more">மேலதிக சமீபத்திய செய்திகள்</div>
            </a>
          </div>
        </div>
      </div>

      <div fxFlex.lg="50" fxFlex.xl="50" fxFlex.md="50" fxFlex.sm="100" fxFlex.xs="100" fxLayout="column"
        fxFlexOrder="2" fxFlexOrder.sm="1" fxFlexOrder.xs="1">
        <div>
          <div class="black_header">
            <!-- top stories -->
            <div class="black_header_title display-flex">முக்கிய செய்திகள்</div>
          </div>
          <div class="main_div top_stories">
            <div *ngFor="let item of stickyPosts  | slice:0:1; let i=index">
              <a href="/{{item.post_url}}">
                <div class="top_image_div">
                  <!-- <img class="top_stories_img" [src]="item.images.large_tile_image" alt={{item.short_title}}> -->
                  <div style="position: relative;" class="top_image_div">
                    <div *ngIf="item.video_post!=null" class="video_play_main">
                      <img src="https://cdn.newsfirst.lk/assets/play.png" alt="">
                    </div>
                    <img width="100% " height="100%" class="top_stories_img" [src]="item.images.large_tile_image"
                      alt={{item.short_title}}>
                  </div>
                </div>
                <div class="top_stories_main">
                  <div>
                    <h1 class="top_stories_header">{{item.short_title}}
                    </h1>
                    <div class="top_stories_details"
                      [innerHTML]="replaceString(item.excerpt.rendered).substring(0,450)+'...'">
                    </div>
                    <div fxLayout="row" class="top_stories_read_more">
                      <div fxFlex="50">
                        <div class="time_date"> {{item.date.split("T")[0]}} | {{item.date.split("T")[1].split(".")[0]}}
                        </div>
                      </div>
                      <div fxFlex="50" class="read_more_main">
                        <div class="read_more">மேலும் வாசிக்க</div>
                      </div>
                    </div>

                  </div>

                </div>
              </a>
            </div>
            <!-- =============================================== -->
            <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="20" class="adver">
              <div fxFlexAlign="center" class="ad_div" fxFlex.xs="100" fxFlex.sm="100" fxLayoutAlign="center"
                fxFlex="100" style="height: 90px;">
                <!-- <a href="https://news1st.lk/manifesto">
                  <img width="100%" src="https://cdn.newsfirst.lk/election/manifesto/manifesto_eng.jpg" alt="">
                </a> -->
                <div class="ads_lap_hide" id="block_4404" style="max-height:90px !important;width: 100% !important;">
                </div>
                <!-- <a class="ads_mobile_hide" href="https://bit.ly/3cW2Q4F" target="_blank" rel="noopener">
                  <img loading="lazy"
                    style=" margin: auto;height:100% !important; width: 100%;max-width: 720px !important; "
                    src="https://bit.ly/3Uu37iU" alt="" />
                </a> -->
                <!-- <div class="ads_mobile_hide" id="block_5077"></div> -->
                <!-- <div style="display:block;margin:auto;max-height:90px !important;width: 100%;">
                    <div id="block_4404" style="max-height:90px !important;width: 100% !important;"></div>
                  </div> -->
              </div>
            </div>
            <!-- =============================================== -->
            <div class="top_stories_sub_news">

              <div fxFlex="row" fxLayoutGap="20">
                <div fxFlex="50" style="   width: 100%;" *ngFor="let item of stickyPosts  | slice:1:3; let i=index ">
                  <a href="/{{item.post_url}}">

                    <div style="position: relative;">
                      <div *ngIf="item.video_post!=null" class="video_play_main">
                        <img src="https://cdn.newsfirst.lk/assets/play.png" alt="">
                      </div>
                      <img loading="lazy" class="sub_img" width="100%" [src]="item.images.mobile_banner"
                        alt={{item.short_title}}>
                    </div>
                    <h2 class="top_stories_sub_title">{{item.short_title}}</h2>
                    <div class="top_stories_sub_title_detail"
                      [innerHtml]="replaceString(item.excerpt.rendered).substring(0, 250)+'...'">
                    </div>

                    <div fxLayout="row" style="margin-top: 15px;">
                      <div fxFlex="50">
                        <div class="time_date"> {{item.date.split("T")[0]}} | {{item.date.split("T")[1].split(".")[0]}}
                        </div>
                      </div>
                      <div fxFlex="50" class="read_more_main">
                        <div class="read_more">மேலும் வாசிக்க</div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div class=" mobile_view" style="margin-top: 10px;">
              <div fxFlex="column">
                <div style=" width: 100%;" *ngFor="let item of stickyPosts  | slice:1:3; let i=index ">
                  <a href="/{{item.post_url}}">
                    <div style="position: relative;">
                      <div *ngIf="item.video_post!=null" class="video_play_main">
                        <img src="https://cdn.newsfirst.lk/assets/play.png" alt="">
                      </div>
                      <img loading="lazy" class="sub_img" width="100%" [src]="item.images.mobile_banner"
                        alt={{item.short_title}}>
                    </div>
                    <div style="padding: 10px;">
                      <h2 class="top_stories_sub_title">{{item.short_title}}</h2>
                      <div fxLayout="row" style="margin-top: 15px;">
                        <div fxFlex="50">
                          <div class="time_date"> {{item.date.split("T")[0]}} |
                            {{item.date.split("T")[1].split(".")[0]}}
                          </div>
                        </div>
                        <div fxFlex="50" class="read_more_main">
                          <div class="read_more">மேலும் வாசிக்க</div>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- ======//========================================= -->
          <div class=" mobile_view">
            <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10" style="margin-block: 5px;"
              class="adver ">
              <!-- <div fxFlexAlign="center" class="ad_div" fxFlex="50" fxFlex.xs="100" fxFlex.sm="100"
                fxLayoutAlign="center">
                <a href="https://lakshapathi.sirasatv.lk/" target="_blank" rel="noopener">
                  <img loading="lazy"
                    style="display:block; margin:auto; max-width:720px !important; width:100% ;height: 100%; "
                    src="https://cdn.newsfirst.lk/advertisements/12-02-2023/play_along_app_banner_728x90.jpg" alt="" />
                </a>
              </div> -->
              <div fxFlexAlign="center" class="ad_div" fxFlex="50" fxFlex.xs="100" fxFlex.sm="100"
                fxLayoutAlign="center">
                <a href="https://bit.ly/news1stviber" target="_blank"><img loading="lazy" class="thumbnail"
                    src="https://cdn.newsfirst.lk/tamil-uploads/2020/07/a261ace6-viberbanner.gif"
                    style="width:100%; max-width:720px;height: 100%;" alt=""> </a>

              </div>
            </div>
          </div>
          <!-- ======//========================================= -->

        </div>
      </div>
      <div fxFlex.lg="25" fxFlex.xl="25" fxFlex.md="25" fxFlex.sm="100" fxFlex.xs="100" fxLayout="column"
        fxFlexOrder="3" fxFlexOrder.sm="3" fxFlexOrder.xs="3">
        <div>
          <div style="position: relative; width: 100%;">
            <div class="black_header" style="background-color: #f8f8fa;">
            </div>
            <div style="margin-bottom: 10px;">
              <!-- <iframe class="hide_ad_lap_n"
                style="margin: auto;    justify-content: end; overflow: hidden; width: 100%;" height="330"
                src="https://cdn.newsfirst.lk/advertisements/09-04-2024/Combo%20Pack%20Tam_330x330/index.html"
                frameborder="0"></iframe>
              <iframe class="hide_ad_mobile_n" style="margin: auto;   justify-content: end; overflow: hidden; "
                src="https://cdn.newsfirst.lk/advertisements/09-04-2024/Combo%20Pack%20Tam_300x70/index.html"
                frameborder="0"></iframe> -->
              <!-- <iframe style="margin: auto;    justify-content: end; overflow: hidden; width: 100%;" height="330"
                src="https://cdn.newsfirst.lk/advertisements/31-10-2024/330x330%20(2)/index.html"
                frameborder="0"></iframe> -->

                <a href="https://mobitel.lk/mobitel-1298" target="_blank">
                  <img
                  style="max-width: 100%;    margin: auto;  display: flex;  justify-content: end;margin-bottom: 10px; max-width: 300px; "
                    src="https://cdn.newsfirst.lk/advertisements/12-06-2025/mobitel_tam.jpeg" alt="">
                </a>


              <!-- <a href=" https://www.mobitel.lk/pocket-pack" target="_blank">
              <img style="max-width: 100%;    margin: auto;  display: flex;  justify-content: end;  "
                src="https://cdn.newsfirst.lk/advertisements/01-10-2024/mobitel_330x330.gif" alt="">
            </a> -->
              <a href="https://news1st.lk/4etYkbj" target="_blank">
                <img
                style="max-width: 100%;    margin: auto;  display: flex;  justify-content: end;margin-bottom: 10px; max-width: 300px; "
                  src="https://cdn.newsfirst.lk/election/advertisment/250x250--1.jpg" alt="">
              </a>

            </div>

          </div>
          <!-- <div>
            <div style="width: 240px;margin-top: 10px;" class="black_header exchange_black_header">
              <h2 class="black_header_title display-flex">பரிமாற்ற விகிதம்</h2>
            </div>
            <div class="exchange_rate">

              <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

                <ng-container matColumnDef="COUNTRY">
                  <th mat-header-cell *matHeaderCellDef> COUNTRY </th>
                  <td mat-cell *matCellDef="let element">
                    <img src="https://cdn.newsfirst.lk/assets/{{element.img}}.webp" alt="img">
                    {{element.country}}
                  </td>
                </ng-container>

                <ng-container matColumnDef="PRICE">
                  <th mat-header-cell *matHeaderCellDef> PRICE </th>
                  <td mat-cell *matCellDef="let element"> {{element.price}} </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
            </div>
          </div> -->
          <div>
            <div style="width: 240px;margin-top: 10px" class="black_header featured_black_header">
              <div class="black_header_title display-flex">செய்தித் தொகுப்பு</div>
            </div>
            <div class="featured_news_main">
              <div *ngFor="let item of featuredPosts | slice:0:3;">
                <a href="/{{item.post_url}}">
                  <div fxLayout="row" fxLayoutGap="10" class="featured" style="margin-top: 20px;">
                    <div fxFlex="30">
                      <!-- <img style="object-fit: cover;" class="featured_img" width="100%"
                        [src]="item.images.mobile_banner" alt={{item.short_title}}> -->
                      <div style="position: relative; cursor: pointer;">
                        <div *ngIf="item.video_post!=null" style="width: 70px;height:70px;" class="video_play_main ">
                          <img src="https://cdn.newsfirst.lk/assets/play.png" alt="">
                        </div>
                        <img loading="lazy" style="object-fit: cover;" height="80px" width="100%"
                          [src]="item.images.post_thumb" alt={{item.short_title}}>
                      </div>
                    </div>
                    <div fxFlex="70">
                      <div class="time_date"> {{item.date.split("T")[0]}} | {{item.date.split("T")[1].split(".")[0]}}
                      </div>
                      <h4 class="sub_news_title">{{item.short_title}}</h4>
                      <div class="sub_news_detail_guest"
                        [innerHtml]="replaceString(item.excerpt.rendered).substring(0, 50)+'...'"></div>
                    </div>
                  </div>
                </a>
                <mat-divider></mat-divider>
              </div>


            </div>
            <div class="Learn_more_main">
              <a href="/featured">
                <div class="display-flex Learn_more">மேலதிக செய்தித் தொகுப்பு </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ===================\\============================ -->

    <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10" style="margin-bottom: 5px;"
      class="adver  margin">
      <div fxFlexAlign="center" class="ad_div" fxFlex="50" fxFlex.xs="100" fxFlex.sm="100" fxLayoutAlign="center">
        <div style="overflow: hidden;max-height: 90px !important">
          <script async
            src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3672728637886288"
            crossorigin="anonymous">
            </script> <!-- News New -->
          <ins class="adsbygoogle" style="display:inline-block;width:728px;height:90px"
            data-ad-client="ca- pub-3672728637886288" data-ad-slot="7381577559"></ins>
          <script>      (adsbygoogle = window.adsbygoogle || []).push({}); </script>
        </div>
      </div>
      <!-- <div fxFlexAlign="center" class="ad_div" fxFlex="50" fxFlex.xs="100" fxFlex.sm="100" fxLayoutAlign="center">
        <div class="ads_lap_hide" id="block_5076" style="max-height:90px !important;">
        </div>
        <div class="ads_mobile_hide" id="block_5077"></div>
      </div> -->
    </div>

    <!-- =====================\\========================== -->

    <div fxLayout="row" fxLayoutGap="10" class="margin" fxLayout.sm="column" fxLayout.xs="column">
      <div fxFlex.lg="75" fxFlex.xl="75" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100" fxLayout="column">
        <div>
          <div class="black_header">
            <div class="black_header_title display-flex">உள்ளூர்</div>
          </div>
          <div class="local_news_main">
            <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
              <div fxFlex="60" *ngFor="let item of localPosts  | slice:0:1; let i=index">
                <div class="border-right-local">
                  <div>
                    <a href="/{{item.post_url}}">
                      <!-- <div>
                        <img width="100%" [src]="item.images.large_tile_image" alt={{item.short_title}}>
                      </div> -->
                      <div style="position: relative;">
                        <div *ngIf="item.video_post!=null" class="video_play_main ">
                          <img src="https://cdn.newsfirst.lk/assets/play.png" alt="">
                        </div>
                        <img loading="lazy" width="100%" height="100%" [src]="item.images.large_tile_image"
                          alt={{item.short_title}}>
                      </div>
                      <h1 class="top_stories_header" style="height: auto !important;">
                        {{item.short_title}}
                      </h1>
                      <div class="top_stories_details">
                        <p class="top_stories_details"
                          [innerHTML]="replaceString(item.content.rendered).substring(0,300)+'...' "></p>
                      </div>
                      <div class="top_stories_read_more">
                        <div fxFlex="60" class="read_more">மேலும் வாசிக்க</div>
                        <!-- <div fxFlex="40" fxLayoutAlign="end" class="read_more">share</div> -->
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div fxFlex="40" class="local_news">
                <!-- Local News  -->
                <div *ngFor="let item of localPosts  | slice:1:5; let i=index">
                  <a href="/{{item.post_url}}">
                    <div fxLayout="row" class="local_news_sub" fxLayoutGap="10">
                      <div style="position: relative;" fxFlex="30">
                        <div *ngIf="item.video_post!=null" style="width: 80px;height:80px;" class="video_play_main ">
                          <img src="https://cdn.newsfirst.lk/assets/play.png" alt="">
                        </div>
                        <img loading="lazy" style="object-fit: cover;" height="90px" width="100%"
                          [src]="item.images.post_thumb" alt={{item.short_title}}>
                      </div>
                      <div fxFlex="70">
                        <div class="time_date">{{item.date.split("T")[0]}} | {{item.date.split("T")[1].split(".")[0]}}
                        </div>
                        <h3 class="top_stories_sub_header">{{item.short_title}}</h3>
                        <div class="top_stories_sub_detail"
                          [innerHTML]="replaceString(item.content.rendered).substring(0,100)+'...'"></div>
                      </div>
                    </div>
                  </a>
                  <mat-divider class="local_news_divider"></mat-divider>

                </div>
                <a href="/local">
                  <div>
                    <div class="read_more display-flex">மேலும் உள்நாட்டு செய்திகள்</div>
                  </div>
                </a>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div fxFlex="25" fxLayout="column">
        <div>
          <div class="black_header">
            <!-- weather -->
            <h2 class="black_header_title display-flex">வானிலை</h2>
          </div>
          <div class="featured_news_main">
            <div>
              <div fxLayout="row" style="height: 100px;">
                <div fxFlex="50" fxLayoutGap="10" class="display-flex">
                  <div>
                    <img src={{temp.todayImg}} alt="img">
                  </div>
                  <div id="current-temp" class="temp"> {{temp.todaytemp}}</div>
                </div>
                <div fxFlex="50" style="position: relative;">
                  <div class="hum_win_main">
                    <div class="hum_win">precip : {{temp.todayPrecip}}%</div>
                    <div class="hum_win"> Humidity : {{temp.todayHum}}%</div>
                    <div class="hum_win"> wind : {{temp.todayWind}} </div>
                  </div>
                </div>
              </div>
              <div class="weather_main">
                <div class="weather_inner">
                  <table class="weather_table">
                    <tr>
                      <th class="table_header" *ngFor="let item of week">{{item}}</th>
                    </tr>
                    <tr class="weather_tr">
                      <td *ngFor="let item of cloudImg">
                        <img src={{item}} alt={{item.short_title}}>
                      </td>
                    </tr>
                    <tr class="weather_tr">
                      <td *ngFor="let item of highTemp">
                        <div id="current-temp" class="temps">{{item}}</div>
                      </td>

                    </tr>
                    <tr class="weather_tr">
                      <td *ngFor="let item of lowTemp">
                        <div id="current-temp" class="temps">{{item}}</div>
                      </td>

                    </tr>
                  </table>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div style="margin-top: 20px;">
          <ins class="adsbygoogle" style="display:inline-block;width:300px;height:250px;"
            data-ad-client="ca-pub-5432073672371728" data-ad-slot="3155889414"></ins>
        </div>
      </div>
    </div>

    <!-- ====================================================== -->
    <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10" class="adver"
      style=" margin-top: 10px;">
      <div fxFlexAlign="center" class="ad_div" fxFlex="100" fxFlex.sm="100" fxFlex.xs="100" fxLayoutAlign="center">
        <ins class="adsbygoogle" style="display:block" data-ad-client="ca-pub-5432073672371728"
          data-ad-slot="1155259484" data-ad-format="auto" data-full-width-responsive="true"></ins>

      </div>
      <!-- <div fxFlexAlign="center" class="ad_div" fxFlex="50" fxFlex.sm="100" fxFlex.xs="100" fxLayoutAlign="center"
        ngStyle.xs="width: 330px;" ngStyle.sm="width: 330px;">
        <ins class="adsbygoogle" style="display:inline-block;width:920px;height:90px"
          data-ad-client="ca-pub-5432073672371728" data-ad-slot="7081168074"></ins>

      </div> -->
    </div>
    <!-- ====================================================== -->
    <!-- ====================================================== -->
    <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10" class="adver"
      style=" margin-top: 10px;">
      <div fxFlexAlign="center" class="ad_div" fxFlex="100" fxFlex.sm="100" fxFlex.xs="100" fxLayoutAlign="center">
        <div style="overflow: hidden;max-height: 90px !important">
          <script async
            src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3672728637886288"
            crossorigin="anonymous">
            </script> <!-- News New -->
          <ins class="adsbygoogle" style="display:inline-block;width:728px;height:90px"
            data-ad-client="ca- pub-3672728637886288" data-ad-slot="7381577559"></ins>
          <script>      (adsbygoogle = window.adsbygoogle || []).push({}); </script>
        </div>

      </div>
      <!-- <div fxFlexAlign="center" class="ad_div" fxFlex="50" fxFlex.sm="100" fxFlex.xs="100" fxLayoutAlign="center"
      ngStyle.xs="width: 330px;" ngStyle.sm="width: 330px;">
      <ins class="adsbygoogle" style="display:inline-block;width:920px;height:90px"
        data-ad-client="ca-pub-5432073672371728" data-ad-slot="7081168074"></ins>

    </div> -->
    </div>
    <!-- ====================================================== -->


    <div fxLayout="row" fxLayoutGap="10" class="margin" fxLayout.sm="column" fxLayout.xs="column">
      <div fxFlex.lg="33" fxFlex.xl="33" fxFlex.md="33" fxFlex.sm="100" fxFlex.xs="100">
        <div class="black_header">
          <h2 class="black_header_title display-flex">விளையாட்டு</h2>
        </div>
        <div class="sports_main">
          <div>
            <div *ngFor="let sportsPost of sportsPosts ; let i=index">
              <a href="/{{sportsPost.post_url}}">
                <div fxLayout="row" fxLayoutGap="10">
                  <div style="position: relative;" fxFlex="30" fxFlex.sm="20" fxFlex.xs="40">
                    <div *ngIf="sportsPost.video_post!=null" style="width: 80px;height:80px;" class="video_play_main ">
                      <img src="https://cdn.newsfirst.lk/assets/play.png" alt="">
                    </div>
                    <img loading="lazy" style="object-fit: cover;" height="100px" width="100%"
                      [src]="sportsPost.images.post_thumb" alt={{sportsPost.short_title}}>
                  </div>
                  <div fxFlex="70" fxFlex.sm="80" fxFlex.xs="60">
                    <div class="time_date">{{sportsPost.date.split("T")[0]}} |
                      {{sportsPost.date.split("T")[1].split(".")[0]}}</div>
                    <h4 class="top_stories_sub_header">{{sportsPost.short_title}}</h4>
                    <div class="top_stories_sub_detail"
                      [innerHTML]="replaceString(sportsPost.content.rendered).substring(0,100)+'...'"> </div>
                  </div>

                </div>
              </a>
              <mat-divider class="sport_divider"></mat-divider>
            </div>


            <a href="/sports">
              <div>
                <div class="read_more display-flex">மேலும் விளையாட்டு செய்திகள்</div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div fxFlex.lg="33" fxFlex.xl="33" fxFlex.md="33" fxFlex.sm="100" fxFlex.xs="100">
        <div class="black_header">
          <h2 class="black_header_title display-flex">உலகம்</h2>
        </div>

        <div class="sports_main">
          <div>
            <div *ngFor="let worldPost of worldPosts ; let i=index">
              <a href="/{{worldPost.post_url}}">
                <div fxLayout="row" fxLayoutGap="10">
                  <div style="position: relative;" fxFlex="30" fxFlex.sm="20" fxFlex.xs="40">
                    <div *ngIf="worldPost.video_post!=null" style="width: 80px;height:80px;" class="video_play_main ">
                      <img src="https://cdn.newsfirst.lk/assets/play.png" alt="">
                    </div>
                    <img loading="lazy" style="object-fit: cover;" height="100px" width="100%"
                      [src]="worldPost.images.post_thumb" alt={{worldPost.short_title}}>
                  </div>
                  <div fxFlex="70" fxFlex.sm="80" fxFlex.xs="60">
                    <div class="time_date">{{worldPost.date.split("T")[0]}} |
                      {{worldPost.date.split("T")[1].split(".")[0]}}</div>
                    <h4 class="top_stories_sub_header">{{worldPost.short_title}}</h4>
                    <div class="top_stories_sub_detail"
                      [innerHTML]="replaceString(worldPost.content.rendered).substring(0,100)+'...'"> </div>
                  </div>

                </div>
              </a>
              <mat-divider class="sport_divider"></mat-divider>
            </div>


            <a href="/world">
              <div>
                <div class="read_more display-flex">மேலும் உலகம் செய்திகள்</div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div fxFlex.lg="33" fxFlex.xl="33" fxFlex.md="33" fxFlex.sm="100" fxFlex.xs="100">
        <div style="width: 228px;" class="black_header">
          <h2 class="black_header_title display-flex">வணிகம்</h2>
        </div>
        <div class="sports_main">
          <div>
            <div *ngFor="let businessPost of businessPosts ; let i=index">
              <a href="/{{businessPost.post_url}}">

                <div fxLayout="row" fxLayoutGap="10">
                  <div fxFlex="30" fxFlex.sm="20" fxFlex.xs="40" style=" height: 100%;position: relative;">
                    <div *ngIf="businessPost.video_post!=null" style="width: 80px;height:80px;"
                      class="video_play_main ">
                      <img src="https://cdn.newsfirst.lk/assets/play.png" alt="">
                    </div>
                    <img loading="lazy" style="object-fit: cover;" height="100px" width="100%"
                      [src]="businessPost.images.post_thumb" alt={{businessPost.short_title}}>
                  </div>
                  <div fxFlex="70" fxFlex.sm="80" fxFlex.xs="60">
                    <div class="time_date">{{businessPost.date.split("T")[0]}} |
                      {{businessPost.date.split("T")[1].split(".")[0]}}</div>
                    <h4 class="top_stories_sub_header">{{businessPost.short_title}}</h4>
                    <div class="top_stories_sub_detail"
                      [innerHTML]="replaceString(businessPost.content.rendered).substring(0,100)+'...'"> </div>
                  </div>
                </div>
              </a>
              <mat-divider class="sport_divider"></mat-divider>
            </div>


            <a href="/business">
              <div>
                <div class="read_more display-flex">மேலும் வணிகச் செய்திகள்</div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>


    <!-- ====================================================== -->
    <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10" class="adver"
      style=" margin-top: 10px;">
      <div fxFlexAlign="center" class="ad_div" fxFlex="100" fxFlex.sm="100" fxFlex.xs="100" fxLayoutAlign="center">
        <ins class="adsbygoogle" style="display:block" data-ad-client="ca-pub-5432073672371728"
          data-ad-slot="1155259484" data-ad-format="auto" data-full-width-responsive="true"></ins>

      </div>
      <!-- <div fxFlexAlign="center" class="ad_div" fxFlex="50" fxFlex.sm="100" fxFlex.xs="100" fxLayoutAlign="center"
        ngStyle.xs="width: 330px;" ngStyle.sm="width: 330px;">
        <ins class="adsbygoogle" style="display:inline-block;width:920px;height:90px"
          data-ad-client="ca-pub-5432073672371728" data-ad-slot="7081168074"></ins>

      </div> -->
    </div>
    <!-- ====================================================== -->
    <!-- =============================================== -->
    <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10" class="adver margin"
      style=" margin-bottom: 20px;">
      <div style="max-height:90px !important;">
        <script async
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3672728637886288"
          crossorigin="anonymous"></script>
        <!-- News New -->
        <ins class="adsbygoogle" style="display:block" data-ad-client="ca-pub-3672728637886288"
          data-ad-slot="7381577559" data-ad-format="auto" data-full-width-responsive="true"></ins>
        <script>      (adsbygoogle = window.adsbygoogle || []).push({}); </script>
      </div>
    </div>
    <!-- =============================================== -->

    <div fxLayout="row" fxLayoutGap="10" class="margin" fxLayout.sm="column" fxLayout.xs="column">
      <div fxFlex="100">
        <div class="black_header">
          <h2 class="black_header_title display-flex">செய்தி அறிக்கை</h2>
        </div>
        <div class="main_div"
          style="background-color: #FFFFFF;border: 1px solid #CCCCCC;height: 320px; position: relative; ">
          <div
            style="width: 50px;height: 50px; background-color: #FFFFFF;box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.15); position: absolute;z-index: 1;top: 0;bottom: 70px;margin: auto; right: 0;border-radius: 100px;">
            <img loading="lazy" style="width: 50px;height:50px ;"
              src="https://storage.googleapis.com/cdn-newsfirst-lk-v2/statics/right.png" alt="right">
          </div>
          <div class="news_bulltins">

            <div class="hor_scroller">

              <div style="width: 350px;height: max-content; margin-right: 20px; ">
                <a href="https://www.youtube.com/playlist?list=PLY5Vy1Ynx1y43TefTx6nenxlp7oj2wC2k" target="_blank">
                  <img loading="lazy" style="width: 100%;height: 180px;"
                    src="https://cdn.newsfirst.lk/assets/Tamil%20Prime%20time%20news%208.png" alt="10pm news">

                  <div class="display-flex" style="  position: relative;bottom: 30px;">
                    <div class="news_bulltins_title_div">
                      <div class="news_title">8 pm Prime Time News</div>
                    </div>
                  </div>
                </a>
              </div>

              <div style="width: 350px;height: max-content; margin-right: 20px; ">
                <a href="https://www.youtube.com/playlist?list=PLY5Vy1Ynx1y43TefTx6nenxlp7oj2wC2k" target="_blank">
                  <img loading="lazy" style="width: 100%;height: 180px;"
                    src="https://cdn.newsfirst.lk/assets/Tamil%20Prime%20time%20news%2010.png" alt="9pm News">

                  <div class="display-flex" style="  position: relative;bottom: 30px;">
                    <div class="news_bulltins_title_div">
                      <div class="news_title">10 pm Prime Time News</div>
                    </div>
                  </div>
                </a>
              </div>
              <div style="width: 350px;height: max-content; margin-right: 20px; ">
                <a href="https://www.youtube.com/playlist?list=PLY5Vy1Ynx1y43TefTx6nenxlp7oj2wC2k" target="_blank">
                  <img loading="lazy" style="width: 100%;height: 180px;"
                    src="https://cdn.newsfirst.lk/assets/Tamil%20%20Lunch%20news%201.png" alt="lunch time news">

                  <div class="display-flex" style="  position: relative;bottom: 30px;">
                    <div class="news_bulltins_title_div">
                      <div class="news_title">Lunch Time News</div>
                    </div>
                  </div>
                </a>
              </div>
              <div style="width: 350px;height: max-content; margin-right: 20px; ">
                <a href="https://www.youtube.com/playlist?list=PLY5Vy1Ynx1y43TefTx6nenxlp7oj2wC2k" target="_blank">
                  <img loading="lazy" style="width: 100%;height: 180px;"
                    src="https://cdn.newsfirst.lk/assets/tamil%20morning%20news%206.45.png" alt="7pm news">

                  <div class="display-flex" style="  position: relative;bottom: 30px;">
                    <div class="news_bulltins_title_div">
                      <div class="news_title">6.45 am Breakfast News</div>
                    </div>
                  </div>
                </a>
              </div>


            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- ====================================================== -->
    <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10" class="adver"
      style=" margin-top: 10px;">
      <div fxFlexAlign="center" class="ad_div" fxFlex="100" fxFlex.sm="100" fxFlex.xs="100" fxLayoutAlign="center">
        <ins class="adsbygoogle" style="display:block" data-ad-client="ca-pub-5432073672371728"
          data-ad-slot="1155259484" data-ad-format="auto" data-full-width-responsive="true"></ins>

      </div>
      <!-- <div fxFlexAlign="center" class="ad_div" fxFlex="50" fxFlex.sm="100" fxFlex.xs="100" fxLayoutAlign="center"
        ngStyle.xs="width: 330px;" ngStyle.sm="width: 330px;">
        <ins class="adsbygoogle" style="display:inline-block;width:920px;height:90px"
          data-ad-client="ca-pub-5432073672371728" data-ad-slot="7081168074"></ins>

      </div> -->
    </div>
    <!-- ====================================================== -->
    <!-- =============================================== -->
    <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10" class="adver margin"
      style=" margin-bottom: 20px;">
      <div style="max-height:90px !important;">
        <script async
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3672728637886288"
          crossorigin="anonymous"></script>
        <!-- News New -->
        <ins class="adsbygoogle" style="display:block" data-ad-client="ca-pub-3672728637886288"
          data-ad-slot="7381577559" data-ad-format="auto" data-full-width-responsive="true"></ins>
        <script>      (adsbygoogle = window.adsbygoogle || []).push({}); </script>
      </div>
    </div>
    <!-- =============================================== -->
    <div fxLayout="row" fxLayoutGap="10" style="margin-top: 50px;" fxLayout.sm="column" fxLayout.xs="column">
      <div fxFlex="100">
        <div class="black_header">
          <h2 class="black_header_title display-flex">தொலைக்காட்சி நிகழ்ச்சிகள்</h2>
        </div>
        <div class="main_div"
          style="background-color: #FFFFFF;border: 1px solid #CCCCCC;height: 320px;width: 100%; position: relative; ">
          <div
            style="width: 50px;height: 50px; background-color: #FFFFFF;box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.15); position: absolute;z-index: 1;top: 0;bottom: 70px;margin: auto; right: 0;border-radius: 100px;">
            <img loading="lazy" style="width: 50px;height:50px ;"
              src="https://storage.googleapis.com/cdn-newsfirst-lk-v2/statics/right.png" alt="right">
          </div>

          <div class="news_bulltins">
            <div class="hor_scroller">
              <div style="width: 350px;height: max-content; margin-right: 20px; ">
                <a href="https://www.youtube.com/playlist?list=PLY5Vy1Ynx1y5QOvSE9Odb7m8Dt2fFoiNe" target="_blank">
                  <img loading="lazy" style="width: 100%;height: 180px;"
                    src="https://cdn.newsfirst.lk/assets/tamil/tamil_1.jpeg" alt="pethikada">

                  <div class="display-flex" style="  position: relative;bottom: 30px;">
                    <div class="news_bulltins_title_div">
                      <div class="news_title">மின்னல்</div>
                    </div>
                  </div>
                </a>
              </div>
              <div style="width: 350px;height: max-content; margin-right: 20px; ">
                <a href="https://www.youtube.com/playlist?list=PLY5Vy1Ynx1y4nSNPmwqUYOnMW2nCh-VUu" target="_blank">
                  <img loading="lazy" style="width: 100%;height: 180px;"
                    src="https://cdn.newsfirst.lk/assets/tamil/samar.jpeg" alt="Satana">

                  <div class="display-flex" style="  position: relative;bottom: 30px;">
                    <div class="news_bulltins_title_div">
                      <div class="news_title">சமர்</div>
                    </div>
                  </div>
                </a>
              </div>
              <div style="width: 350px;height: max-content; margin-right: 20px; ">
                <a href="https://www.youtube.com/playlist?list=PLY5Vy1Ynx1y5QrvszppQBLTD3Wo8YYTH6" target="_blank">
                  <img loading="lazy" style="width: 100%;height: 180px;"
                    src="https://cdn.newsfirst.lk/assets/tamil/news_line.jpeg" alt="Dawasa">
                  <div class="display-flex" style="  position: relative;bottom: 30px;">
                    <div class="news_bulltins_title_div">
                      <div class="news_title">நியுஸ் லைன்</div>
                    </div>
                  </div>
                </a>
              </div>
              <div style="width: 350px;height: max-content; margin-right: 20px; ">
                <a href="https://www.youtube.com/playlist?list=PLY5Vy1Ynx1y6P6bpExGh7VHo8MgxMsIZH" target="_blank">
                  <img loading="lazy" style="width: 100%;height: 180px;"
                    src="https://cdn.newsfirst.lk/assets/tamil/mawatha.jpeg" alt="Ilakkaya">

                  <div class="display-flex" style="  position: relative;bottom: 30px;">
                    <div class="news_bulltins_title_div">
                      <div class="news_title">புதிய பாதை</div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <!-- ====================================================== -->
    <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10" class="adver"
      style=" margin-top: 10px;">
      <div fxFlexAlign="center" class="ad_div" fxFlex="100" fxFlex.sm="100" fxFlex.xs="100" fxLayoutAlign="center">
        <ins class="adsbygoogle" style="display:block" data-ad-client="ca-pub-5432073672371728"
          data-ad-slot="1155259484" data-ad-format="auto" data-full-width-responsive="true"></ins>

      </div>
      <!-- <div fxFlexAlign="center" class="ad_div" fxFlex="50" fxFlex.sm="100" fxFlex.xs="100" fxLayoutAlign="center"
   ngStyle.xs="width: 330px;" ngStyle.sm="width: 330px;">
   <ins class="adsbygoogle" style="display:inline-block;width:920px;height:90px"
     data-ad-client="ca-pub-5432073672371728" data-ad-slot="7081168074"></ins>

 </div> -->
    </div>
    <!-- ====================================================== -->
    <!-- =============================================== -->
    <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10" class="adver margin"
      style=" margin-bottom: 20px;">
      <div style="max-height:90px !important;">
        <script async
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3672728637886288"
          crossorigin="anonymous"></script>
        <!-- News New -->
        <ins class="adsbygoogle" style="display:block" data-ad-client="ca-pub-3672728637886288"
          data-ad-slot="7381577559" data-ad-format="auto" data-full-width-responsive="true"></ins>
        <script>      (adsbygoogle = window.adsbygoogle || []).push({}); </script>
      </div>
    </div>
    <!-- =============================================== -->
  </div>

</div>
